<div
  class="file-uploader-container"
  [ngClass]="{ error: hasError, 'reduced-width': reducedWidth }"
>
  <motif-file-uploader
    [accept]="acceptedFormats"
    [label]="dropMessage"
    [labelDescription]="allowedFormatsMessage"
    [error]="hasError"
    [errorMessage]="errorMessage"
    [errorDescription]="'Make sure the file is not opened by another app before uploading it.'"
    [maxFiles]="1"
    (filesChange)="onFilesChange($event)"
  >
    <motif-file-uploader-dropzone slot="dropzone">
      <motif-file-uploader-dropzone-content>
        
      </motif-file-uploader-dropzone-content>
      <p style="color: white; font-weight: bold; font-size: small;">
        Make sure the file is not opened by another app before uploading it.
      </p>
     </motif-file-uploader-dropzone>

    @if (file && !hasError) {
    <motif-file-uploader-item
      [fileName]="file.name"
      [fileSize]="file.size"
      [removable]="true"
      [uploaded]="true"
      uploadedText="Ready to upload"
      (remove)="onFileRemove($event)"
    ></motif-file-uploader-item>
    }
    
  </motif-file-uploader>

  <!-- for accessibility screen reader -->
  @if(file && !hasError){
  <div id="upload-status" aria-live="assertive" class="sr-only">
    File uploaded successfully
  </div>
  }
</div>
